<template>
  <div>
    <div class="is-fullwidth">
      <spinner-round
        v-if="loading"
        :is-loading="loading" />
      <table-controls-vue
        v-if="!loading && items.length"
        :has-sticky="true"
        :no-scroll-direction="true"
        classes="is-marginless-bottom">
        <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-small has-actionsontd">
          <thead class="has-cells-vcentered">
            <tr class="is-size-6">
              <th
                class="is-paddingless has-text-centered"
                style="z-index:2;">
              </th>
              <th>
                Date
              </th>
              <th>
                Type
              </th>
              <th>
                Message
              </th>
            </tr>
          </thead>
          <tbody class="has-cells-vcentered">
            <tr
              v-for="(option) in items"
              :id="'e' + option.pk"
              :key="option.pk"
              class="is-size-6">
              <td class="has-text-centered">
                <span
                  class="dot tooltip is-tooltip-right"
                  :class="option.is_error | dotClass" />
              </td>
              <td class="is-narrow is-padding-left-xsmall is-padding-right-small">
                {{ getDate(option.created_on) }}
              </td>
              <td
                v-if="isSage === false"
                class="is-narrow is-padding-left-xsmall is-padding-right-small">
                {{ option.connection_type }}
              </td>
              <td
                v-else
                class="is-narrow is-padding-left-xsmall is-padding-right-small">
                Sage
              </td>
              <td>
                {{ option.is_error ? getError(option.error) : option.message }}
              </td>
            </tr>
          </tbody>
        </table>
      </table-controls-vue>
      <div v-show="!loading && !items.length">
        <div class="is-padding">
          <h2 class="title is-3 has-text-weight-bold">
            Aucun historique
          </h2>
        </div>
      </div>
      <pagination
        :loading="loading"
        :current-page="currentPage"
        :total-page="totalPage"
        @changePage="loadItems($event)" />
    </div>
  </div>
</template>

<script>
import { GenericList, Filter, Sort, DefaultValues, ColumnConf, Option, FilterGetter, Multiselection } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'ExternalConnectionHistory',
  filters: {
    dotClass (value) {
      if (value === true) {
        return 'has-background-danger'
      } else {
        return 'has-background-success'
      }
    }
  },
  mixins: [GenericList, Filter, Sort, DefaultValues, ColumnConf, Option, FilterGetter, Multiselection],
  data () {
    return {
      setQueryAtStart: true,
      loadDocuments: this.loadItems,
      items: [],
      isSage: false
    }
  },
  computed: {
    ...mapState(['currentAdv', 'device']),
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur']),
    ...mapGetters({ storeAccounts: 'accounts' })
  },
  async created () {
    await this.isSageConnector()
  },
  methods: {
    // Créez le back pour les historique
    async loadItems (page = null, perPage = null) {
      this.loading = true
      if (this.beforeGet) this.beforeGet()
      if (page) this.query.page = page
      if (perPage) this.query.per_page = perPage
      else this.query.per_page = this.perPage
      if (!this.currentAdv.promoteur.sage_connector) {
        const { data } = await this.$api.get(this.$resources.RESERVATION_EXTERNAL_CONNECTION_HISTORY(this.currentAdv.pk))
        this.successGet(data)
      } else {
        const { data } = await this.$api.get(this.$resources.RESERVATION_SAGE_CONNECTOR_HISTORY(this.currentAdv.pk))
        this.successGet(data)
      }
    },
    getError (errors) {
      if (!Array.isArray(errors)) {
        errors = [errors]
      }
      return errors.join(', ')
    },
    getDate (date) {
      return moment(date).add(2, 'hours').format('LLL')
    },
    async isSageConnector () {
      if (this.currentAdv.promoteur.sage_connector) {
        this.isSage = true
      }
    }
  }
}
</script>
